module.exports = __webpack_public_path__ + "img/Artis J Mc Campbell.3a8eff66.jpg";